/**
 * 국가 목록 데이터
 * ISO 3166-1 alpha-3 코드 기반
 */
export const COUNTRY_LIST = [
  { text: '가나', value: 'GHA' },
  { text: '가봉', value: 'GAB' },
  { text: '가이아나', value: 'GUY' },
  { text: '감비아', value: 'GMB' },
  { text: '과테말라', value: 'GTM' },
  { text: '그레나다', value: 'GRD' },
  { text: '그리스', value: 'GRC' },
  { text: '기니', value: 'GIN' },
  { text: '기니비사우', value: 'GNB' },
  { text: '나미비아', value: 'NAM' },
  { text: '나우루', value: 'NRU' },
  { text: '나이지리아', value: 'NGA' },
  { text: '남수단', value: 'SSD' },
  { text: '남아프리카공화국', value: 'ZAF' },
  { text: '네덜란드', value: 'NLD' },
  { text: '네팔', value: 'NPL' },
  { text: '노르웨이', value: 'NOR' },
  { text: '뉴질랜드', value: 'NZL' },
  { text: '니우에', value: 'NIU' },
  { text: '니제르', value: 'NER' },
  { text: '니카라과', value: 'NIC' },
  { text: '대만', value: 'TWN' },
  { text: '대한민국', value: 'KOR' },
  { text: '덴마크', value: 'DNK' },
  { text: '도미니카공화국', value: 'DOM' },
  { text: '도미니카연방', value: 'DMA' },
  { text: '독일', value: 'DEU' },
  { text: '동티모르', value: 'TLS' },
  { text: '라오스', value: 'LAO' },
  { text: '라이베리아', value: 'LBR' },
  { text: '라트비아', value: 'LVA' },
  { text: '레바논', value: 'LBN' },
  { text: '레소토', value: 'LSO' },
  { text: '루마니아', value: 'ROU' },
  { text: '룩셈부르크', value: 'LUX' },
  { text: '르완다', value: 'RWA' },
  { text: '리비아', value: 'LBY' },
  { text: '리투아니아', value: 'LTU' },
  { text: '리히텐슈타인', value: 'LIE' },
  { text: '마다가스카르', value: 'MDG' },
  { text: '마셜제도', value: 'MHL' },
  { text: '마카오', value: 'MAC' },
  { text: '말라위', value: 'MWI' },
  { text: '말레이시아', value: 'MYS' },
  { text: '말리', value: 'MLI' },
  { text: '멕시코', value: 'MEX' },
  { text: '모나코', value: 'MCO' },
  { text: '모로코', value: 'MAR' },
  { text: '모리셔스', value: 'MUS' },
  { text: '모리타니아', value: 'MRT' },
  { text: '모잠비크', value: 'MOZ' },
  { text: '몬테네그로', value: 'MNE' },
  { text: '몰도바', value: 'MDA' },
  { text: '몰디브', value: 'MDV' },
  { text: '몰타', value: 'MLT' },
  { text: '몽골', value: 'MNG' },
  { text: '미국', value: 'USA' },
  { text: '미얀마', value: 'MMR' },
  { text: '미크로네시아', value: 'FSM' },
  { text: '바누아투', value: 'VUT' },
  { text: '바레인', value: 'BHR' },
  { text: '바베이도스', value: 'BRB' },
  { text: '바티칸시국', value: 'VAT' },
  { text: '바하마', value: 'BHS' },
  { text: '방글라데시', value: 'BGD' },
  { text: '베냉', value: 'BEN' },
  { text: '베네수엘라', value: 'VEN' },
  { text: '베트남', value: 'VNM' },
  { text: '벨기에', value: 'BEL' },
  { text: '벨라루스', value: 'BLR' },
  { text: '벨리즈', value: 'BLZ' },
  { text: '보스니아헤르체고비나', value: 'BIH' },
  { text: '보츠와나', value: 'BWA' },
  { text: '볼리비아', value: 'BOL' },
  { text: '부룬디', value: 'BDI' },
  { text: '부르키나파소', value: 'BFA' },
  { text: '부탄', value: 'BTN' },
  { text: '북마케도니아', value: 'MKD' },
  { text: '북한', value: 'PRK' },
  { text: '불가리아', value: 'BGR' },
  { text: '브라질', value: 'BRA' },
  { text: '브루나이', value: 'BRN' },
  { text: '사모아', value: 'WSM' },
  { text: '사우디아라비아', value: 'SAU' },
  { text: '산마리노', value: 'SMR' },
  { text: '상투메프린시페', value: 'STP' },
  { text: '세네갈', value: 'SEN' },
  { text: '세르비아', value: 'SRB' },
  { text: '세이셸', value: 'SYC' },
  { text: '세인트루시아', value: 'LCA' },
  { text: '세인트빈센트그레나딘', value: 'VCT' },
  { text: '세인트키츠네비스', value: 'KNA' },
  { text: '소말리아', value: 'SOM' },
  { text: '솔로몬제도', value: 'SLB' },
  { text: '수단', value: 'SDN' },
  { text: '수리남', value: 'SUR' },
  { text: '스리랑카', value: 'LKA' },
  { text: '스웨덴', value: 'SWE' },
  { text: '스위스', value: 'CHE' },
  { text: '스페인', value: 'ESP' },
  { text: '슬로바키아', value: 'SVK' },
  { text: '슬로베니아', value: 'SVN' },
  { text: '시에라리온', value: 'SLE' },
  { text: '싱가포르', value: 'SGP' },
  { text: '아랍에미리트', value: 'ARE' },
  { text: '아르메니아', value: 'ARM' },
  { text: '아르헨티나', value: 'ARG' },
  { text: '아이슬란드', value: 'ISL' },
  { text: '아이티', value: 'HTI' },
  { text: '아일랜드', value: 'IRL' },
  { text: '아제르바이잔', value: 'AZE' },
  { text: '아프가니스탄', value: 'AFG' },
  { text: '안도라', value: 'AND' },
  { text: '알바니아', value: 'ALB' },
  { text: '알제리', value: 'DZA' },
  { text: '앙골라', value: 'AGO' },
  { text: '앤티가바부다', value: 'ATG' },
  { text: '에리트레아', value: 'ERI' },
  { text: '에스토니아', value: 'EST' },
  { text: '에스와티니', value: 'SWZ' },
  { text: '에콰도르', value: 'ECU' },
  { text: '에티오피아', value: 'ETH' },
  { text: '엘살바도르', value: 'SLV' },
  { text: '영국', value: 'GBR' },
  { text: '예멘', value: 'YEM' },
  { text: '오만', value: 'OMN' },
  { text: '오스트레일리아', value: 'AUS' },
  { text: '오스트리아', value: 'AUT' },
  { text: '온두라스', value: 'HND' },
  { text: '요르단', value: 'JOR' },
  { text: '우간다', value: 'UGA' },
  { text: '우루과이', value: 'URY' },
  { text: '우즈베키스탄', value: 'UZB' },
  { text: '우크라이나', value: 'UKR' },
  { text: '이라크', value: 'IRQ' },
  { text: '이란', value: 'IRN' },
  { text: '이스라엘', value: 'ISR' },
  { text: '이집트', value: 'EGY' },
  { text: '이탈리아', value: 'ITA' },
  { text: '인도', value: 'IND' },
  { text: '인도네시아', value: 'IDN' },
  { text: '일본', value: 'JPN' },
  { text: '자메이카', value: 'JAM' },
  { text: '잠비아', value: 'ZMB' },
  { text: '적도기니', value: 'GNQ' },
  { text: '조지아', value: 'GEO' },
  { text: '중국', value: 'CHN' },
  { text: '중앙아프리카공화국', value: 'CAF' },
  { text: '지부티', value: 'DJI' },
  { text: '짐바브웨', value: 'ZWE' },
  { text: '차드', value: 'TCD' },
  { text: '체코', value: 'CZE' },
  { text: '칠레', value: 'CHL' },
  { text: '카메룬', value: 'CMR' },
  { text: '카보베르데', value: 'CPV' },
  { text: '카자흐스탄', value: 'KAZ' },
  { text: '카타르', value: 'QAT' },
  { text: '캄보디아', value: 'KHM' },
  { text: '캐나다', value: 'CAN' },
  { text: '케냐', value: 'KEN' },
  { text: '코모로', value: 'COM' },
  { text: '코소보', value: 'XKX' },
  { text: '코스타리카', value: 'CRI' },
  { text: '코트디부아르', value: 'CIV' },
  { text: '콜롬비아', value: 'COL' },
  { text: '콩고공화국', value: 'COG' },
  { text: '콩고민주공화국', value: 'COD' },
  { text: '쿠바', value: 'CUB' },
  { text: '쿠웨이트', value: 'KWT' },
  { text: '쿡제도', value: 'COK' },
  { text: '크로아티아', value: 'HRV' },
  { text: '키르기스스탄', value: 'KGZ' },
  { text: '키리바시', value: 'KIR' },
  { text: '키프로스', value: 'CYP' },
  { text: '타지키스탄', value: 'TJK' },
  { text: '탄자니아', value: 'TZA' },
  { text: '태국', value: 'THA' },
  { text: '토고', value: 'TGO' },
  { text: '통가', value: 'TON' },
  { text: '투르크메니스탄', value: 'TKM' },
  { text: '투발루', value: 'TUV' },
  { text: '튀니지', value: 'TUN' },
  { text: '터키', value: 'TUR' },
  { text: '트리니다드토바고', value: 'TTO' },
  { text: '파나마', value: 'PAN' },
  { text: '파라과이', value: 'PRY' },
  { text: '파키스탄', value: 'PAK' },
  { text: '파푸아뉴기니', value: 'PNG' },
  { text: '팔라우', value: 'PLW' },
  { text: '팔레스타인', value: 'PSE' },
  { text: '페루', value: 'PER' },
  { text: '포르투갈', value: 'PRT' },
  { text: '폴란드', value: 'POL' },
  { text: '프랑스', value: 'FRA' },
  { text: '피지', value: 'FJI' },
  { text: '핀란드', value: 'FIN' },
  { text: '필리핀', value: 'PHL' },
  { text: '헝가리', value: 'HUN' },
  { text: '홍콩', value: 'HKG' },
  { text: '러시아', value: 'RUS' },
  { text: '기타', value: 'ETC' },
];

/**
 * 국가 코드로 국가명 조회
 * @param {string} code - 국가 코드 (ISO 3166-1 alpha-3)
 * @returns {string} 국가명
 */
export function getCountryNameByCode(code) {
  if (!code) return '';
  const country = COUNTRY_LIST.find((item) => item.value === code);
  return country ? country.text : '기타';
}
